export default __webpack_public_path__ + "static/media/1inch.44215be7.png";